export default __webpack_public_path__ + "static/media/Interaction_Handshake.02d02917.svg";